import { render, staticRenderFns } from "./PecaFornecedorForm.vue?vue&type=template&id=3cb91364"
import script from "./PecaFornecedorForm.vue?vue&type=script&lang=js"
export * from "./PecaFornecedorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports